import React, { Suspense, lazy, memo, useEffect, useState } from "react";
import styled from "styled-components";

import { ReactComponent as BackIcon } from "../../Assets/icons/arrowBack.svg";

import { useTranslate } from '@tolgee/react';

import { ReactComponent as PlusIcon } from "../../Assets/icons/PlusIcon.svg";

import _ from "lodash";
import { FixedSizeList as List } from "react-window"; // Import react-window
import FoundContactElement from "../Chat/FoundContactElement";
import PrimaryButton from "../GenericComponents/PrimaryButton";
import SearchMenu from "../GenericComponents/SearchMenu";
import { NEW_CONTACT } from "../../Constants/constantValues";



const AddMembers = ({
  contacts,
  handleSelectContact,
  handleInviteContact,
  selectedContacts,
  initialContacts,
  setOption,
  setIsAddNewContactOpen,
  groupDetailsSide,
  handleBackBtn,
  handleSaveBtn,

}) => {

  const [searchInput, setSearchInput] = useState("")


  const [confirmDisabled, setConfirmDisabled] = useState(true);



  const ceckSelectedItem = (contact) => {
    let selected = false;

    if (groupDetailsSide) {
      let foundInSelected = selectedContacts.find(
        (element) => element.id === contact.id
      );
      let foundInInitial = initialContacts.find(
        (element) => element.id === contact.id
      );

      if (foundInSelected || foundInInitial) {
        selected = true;
      } else {
        selected = false;
      }
    } else {
      if (selectedContacts.find((item) => item.id === contact.id)) {
        selected = true;
      } else {
        selected = false;
      }
    }
    return selected;
  };

  const searchMember = (list) => {
    if (searchInput === "") {
      return list;
    }

    let found = list.filter((item) =>
      item.name?.toLowerCase().includes(searchInput?.toLowerCase())
    );

    return found;
  };

  const checkChanges = () => {
    if (_.isEqual(selectedContacts, initialContacts)) {
      setConfirmDisabled(true);
    } else {
      setConfirmDisabled(false);
    }
  };

  useEffect(() => {
    checkChanges();
  }, [selectedContacts, contacts]);
  const { t } = useTranslate();
  return (
    <Wrapper>
      <Container>
        <HeaderSection style={{ justifyContent: "start" }} >
          <BackButton onClick={() => handleBackBtn()}>
            <BackIcon />
            {t('general.back')}
          </BackButton>
        </HeaderSection>
        <HeaderSection style={{ minWidth: "150px" }}>
          <ProfileTitle>
            <h1>{t('new_chat.add_members')}</h1>
          </ProfileTitle>
        </HeaderSection>
        <HeaderSection style={{ justifyContent: "end" }} >
          {!confirmDisabled &&
            <PrimaryButton
              disabled={confirmDisabled}
              onClick={() => handleSaveBtn()}
              text={t('general.save')}
            />
          }
        </HeaderSection>

      </Container>

      <ContentContainer>
        <Group>
          <TitleWrapper>
            <h1>{t('new_chat.search_member')}</h1>
          </TitleWrapper>


          <SearchMenu
            value={searchInput}
            setvalue={setSearchInput}
            placeholder={t('general.search')}
          />
        </Group>
        <Group>
          <PrimaryButton
            style={{ padding: "16px" }}
            onClick={() => {
              groupDetailsSide
                ? setOption(NEW_CONTACT)
                : setIsAddNewContactOpen(true);
            }}
            text={t('new_chat.new_contact')}
            iconLeft={<PlusIcon />}
          />

        </Group>

        <Group>
          <TitleWrapper>
            <h1>{t('new_chat.contacts_on_emotii')}</h1>
          </TitleWrapper>
          <OptionWrapper>
            {contacts &&
              contacts.on_app_contacts?.length > 0 &&
              searchMember(contacts.on_app_contacts).map((contact) => (
                <FoundContactElement
                  key={contact.id}
                  item={contact}
                  handleSelectContact={handleSelectContact}
                  selected={ceckSelectedItem(contact)}
                />
              ))}
          </OptionWrapper>
        </Group>
        {contacts && contacts.outside_contacts?.length > 0 && (
          <Group>
            <TitleWrapper>
              <h1>{t('new_chat.invite_to_emotii')}</h1>
            </TitleWrapper>
            <OptionWrapper>
              <List
                height={600} // Adjust this based on the height of the container
                itemCount={searchMember(contacts.outside_contacts).length}
                itemSize={70} // Adjust based on the size of each contact element
                width="100%" // Full width of the container
              >
                {({ index, style }) => {
                  const contact = searchMember(contacts.outside_contacts)[index];
                  return (
                    <FoundContactElement
                      style={style}
                      key={contact.id}
                      item={contact}
                      invite
                      handleInvite={handleInviteContact}
                    />
                  )
                }}
              </List>
            </OptionWrapper>
          </Group>
        )}
      </ContentContainer>
    </Wrapper>
  );
};

export default AddMembers;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height:100%;
  overflow:hidden;
`;

const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Container = styled.div`
display:flex;
justify-content:space-between;
padding: 19px 16px;
align-items:center;
background:${({ theme }) => theme.menu.background};
border-bottom:1px solid ${({ theme }) => theme.sidebar.borderColor};
gap:20px;
`;

const BackButton = styled.button`
color:${({ theme }) => theme.menu.primaryTextColor};
gap:10px;
font-size: 16px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
display:flex;
align-items:center;
justify-content:center;
border:none;
background:none;
cursor:pointer;
`



const ProfileTitle = styled.div`
  display: flex;
  flex-direction: column;
  gap: px;
overflow:hidden;
h1{
  color: ${({ theme }) => theme.menu.primaryTextColor};
  font-weight: 700;
  font-size: 20px;
  line-height: 32px;
  letter-spacing: 0.04px;
  vertical-align: middle;

}
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  h1 {
  color:${({ theme }) => theme.menu.secondaryTextColor};
  font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    text-transform: uppercase;
  }
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
height:100%;
    overflow:auto;
      background: ${({ theme }) => theme.menu.groupContentBackground};
`;


const HeaderSection = styled.div`
display:flex;
width:100%;
min-width:50px;
justify-content:center;
`
const ContentContainer = styled.div`
padding: 19px 16px;
  display: flex;
  flex-direction: column;
  gap: 25px;
  background:${({ theme }) => theme.menu.background};
border-bottom:1px solid ${({ theme }) => theme.sidebar.borderColor};

height:100%;
overflow:auto;
`